import React, {useState} from "react";
import { v4 as uuidv4 } from 'uuid';

const Wysiwyg = ({ callback, currentAnswer, navCallback, currentIndex, lastPosition }) => {
  const answer = currentAnswer ? currentAnswer.answer : null;
  const [ state, setState] = useState(null);

  const handleClick = (e) => {
    const answer = e.target.value;
    callback(answer);
  }

  const handleClickNav = (e) => {
    console.log(e.target.value);
    const direction = e.target.dataset.direction;
    navCallback(document.getElementById('textarea').value, direction);
  }

  return (
    <>
      <div key={uuidv4()}>
        <textarea
          key={uuidv4()}
          id={ 'textarea' }
          name={ 'text' }
          className="rounded-tl-3xl rounded-br-3xl border-gray-400 border w-full px-4 py-4"
          placeholder="ex. antal manluckor, belysning mm."
          rows="5"
          cols="33"
          defaultValue={answer}
          onBlur={handleClick}
        />
      </div>

      <div className={'text-center mt-20'}>
        {currentIndex !== 0 ?
          <button className={'btn text-medium no-underline text-black inline-block px-1 py-1 bg-white rounded-tl-lg rounded-br-lg py-3 px-6'} onClick={handleClickNav} data-direction={'prev'}>{'Föregående'}</button>
        : null}
        <span className={'mx-4'}>
          <span className={'text-base'}>{ ' ' + (currentIndex+1) } /</span>
          <span className={'text-base'}>{ ' ' + (lastPosition+1) + ' ' }</span>
        </span>
        {currentIndex !== lastPosition ?
          <button className={'btn text-medium no-underline text-black inline-block px-1 py-1 bg-white rounded-tl-lg rounded-br-lg py-3 px-6'} onClick={handleClickNav} data-direction={'next'}>{'Nästa'}</button>
        : null}
      </div>
    </>
  );
};

export default Wysiwyg;
